// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import vimeoWidget from './js/widgets/vimeoWidget.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardWidget7 from './js/widgets/cardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  if (globalThis.location.pathname === '/') {
    vimeoWidget();
    seoWidget();
    cardWidget7();
    eventsWidget();
    sponsors();
  }
});
